import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrBI: CultureInfo = {
  name: 'fr-BI',
  displayName: 'français (Burundi)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-BI',
  parent: CultureInfoFr
};
